import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { Collection } from '../../collection';

@Component({
  selector: 'app-collection-list-item',
  templateUrl: './collection-list-item.component.html',
  styleUrls: ['./collection-list-item.component.scss'],
})
export class CollectionListItemComponent {
  @Input() isHighlighted = false;

  @Input() collection: Collection;

  @Output() navigate = new EventEmitter();

  constructor(private router: Router) {}

  @HostListener('click')
  click() {
    this.navigate.emit();

    return this.router.navigate(['collections', this.collection.collectionId]);
  }
}
